module.exports = __webpack_public_path__ + "static/media/Garth.e6d553fc.png";